import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Table, FormControl, Button, Modal } from 'react-bootstrap';
import s from './ManageBannerList.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { getBannerPlacements, addBannerPlacement, editBannerPlacement, deleteBannerPlacement } from '../../../actions/siteadmin/Banner/bannerPlacementActions';
import history from '../../../history';

class ManageBannerPlacement extends React.Component {
  static propTypes = {
    placements: PropTypes.array,
    getBannerPlacements: PropTypes.func.isRequired,
    addBannerPlacement: PropTypes.func.isRequired,
    editBannerPlacement: PropTypes.func.isRequired,
    deleteBannerPlacement: PropTypes.func.isRequired,
  };

  state = {
    showModal: false,
    isEdit: false,
    placementId: null,
    placementName: '',
    placementLabel: '',
    placementHeight: '',
    placementWidth: '',
  };

  componentDidMount() {
    this.props.getBannerPlacements();
  }

  openModal = (placement = null) => {
    if (placement) {
      this.setState({
        showModal: true,
        isEdit: true,
        placementId: placement.id,
        placementName: placement.name,
        placementLabel: placement.label,
        placementHeight: placement.height || '',
        placementWidth: placement.width || '',
      });
    } else {
      this.setState({
        showModal: true,
        isEdit: false,
        placementId: null,
        placementName: '',
        placementLabel: '',
        placementHeight: '',
        placementWidth: '',
      });
    }
  };

  closeModal = () => {
    this.setState({ showModal: false, placementId: null, placementName: '', placementLabel: '', isEdit: false });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSave = async () => {
    const { placementName, placementLabel, placementHeight, placementWidth, isEdit, placementId } = this.state;
    const payload = {
      name: placementName,
      label: placementLabel,
      height: placementHeight ? parseInt(placementHeight, 10) : undefined,
      width: placementWidth ? parseInt(placementWidth, 10) : undefined,
    };
    if (isEdit) {
      await this.props.editBannerPlacement({ id: placementId, ...payload });
    } else {
      await this.props.addBannerPlacement(payload);
    }
    this.closeModal();
    await this.props.getBannerPlacements();
  };

  handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this placement?')) {
      await this.props.deleteBannerPlacement(id);
      await this.props.getBannerPlacements();
    }
  };

  render() {
    const { placements = [] } = this.props;
    const { showModal, placementName, placementLabel, isEdit, placementHeight, placementWidth } = this.state;
    return (
      <div className={s.root}>
        <div className={s.widthInner}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 20
            }}
          >
            <div style={{ alignItems: "center", gap: 12 }}>
              <Button
                variant="outline-secondary"
                type="button"
                onClick={() =>
                  history && history.push && history.push("/siteadmin/banner")
                }
                style={{ marginBottom: 16, fontWeight: 600 }}
              >
                &#8592; Go Back
              </Button>
              <h3 style={{ margin: 0 }}>Manage Banner Placement</h3>
            </div>
            <Button onClick={() => this.openModal()} className={s.addlinkBtn}>
              + Add Placement
            </Button>
          </div>
          <Table className="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Label</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {placements && placements.length > 0 ? (
                placements.map((placement, idx) => (
                  <tr key={placement.id}>
                    <td>{idx + 1}</td>
                    <td>{placement.name}</td>
                    <td>{placement.label}</td>
                    <td>
                      <Button
                        size="sm"
                        variant="info"
                        onClick={() => this.openModal(placement)}
                        style={{ marginRight: 8 }}
                      >
                        Edit
                      </Button>
                      <Button
                        size="sm"
                        variant="danger"
                        onClick={() => this.handleDelete(placement.id)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No placement found.</td>
                </tr>
              )}
            </tbody>
          </Table>
          <Modal show={showModal} onHide={this.closeModal}>
            <Modal.Header closeButton>
              <Modal.Title>
                {isEdit ? "Edit Placement" : "Add Placement"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <div>
                <label
                  htmlFor="placementNameInput"
                  style={{ marginBottom: 6, display: "block", fontWeight: 500 }}
                >
                  Name
                </label>
                <FormControl
                  id="placementNameInput"
                  name="placementName"
                  type="text"
                  placeholder="Name"
                  value={placementName}
                  onChange={this.handleChange}
                  style={{ borderRadius: 8, height: 40 }}
                />
              </div>
              <div>
                <label
                  htmlFor="placementLabelInput"
                  style={{ marginBottom: 6, display: "block", fontWeight: 500 }}
                >
                  Label
                </label>
                <FormControl
                  id="placementLabelInput"
                  name="placementLabel"
                  type="text"
                  placeholder="Label"
                  value={placementLabel}
                  onChange={this.handleChange}
                  style={{ borderRadius: 8, height: 40 }}
                />
              </div>
              <div style={{ display: "flex", gap: 12 }}>
                <div style={{ marginBottom: 16, width: "100%" }}>
                  <label
                    htmlFor="placementHeightInput"
                    style={{ marginBottom: 6, display: "block", fontWeight: 500 }}
                  >
                    Height
                  </label>
                  <FormControl
                    id="placementHeightInput"
                    name="placementHeight"
                    type="number"
                    placeholder="Height"
                    value={this.state.placementHeight}
                    onChange={this.handleChange}
                    style={{ borderRadius: 8, height: 40 }}
                    min={1}
                  />
                </div>
                <span style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "10px", fontSize: "24px", fontWeight: "bold" }}>
                  :
                </span>
                <div style={{ marginBottom: 16, width: "100%" }}>
                  <label
                    htmlFor="placementWidthInput"
                    style={{ marginBottom: 6, display: "block", fontWeight: 500 }}
                  >
                    Width
                  </label>
                  <FormControl
                    id="placementWidthInput"
                    name="placementWidth"
                    type="number"
                    placeholder="Width"
                    value={this.state.placementWidth}
                    onChange={this.handleChange}
                    style={{ borderRadius: 8, height: 40 }}
                    min={1}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.closeModal}
                style={{ borderRadius: 8, minWidth: 90 }}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={this.handleSave}
                disabled={
                  !placementName.trim() ||
                  !placementLabel.trim() ||
                  !placementHeight ||
                  !placementWidth ||
                  isNaN(Number(placementHeight)) ||
                  isNaN(Number(placementWidth)) ||
                  Number(placementHeight) < 1 ||
                  Number(placementWidth) < 1
                }
                style={{ borderRadius: 8, minWidth: 90 }}
              >
                Save
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  placements: state.adminBanners && state.adminBanners.placements
});

const mapDispatch = (dispatch) => bindActionCreators({ getBannerPlacements, addBannerPlacement, editBannerPlacement, deleteBannerPlacement }, dispatch);

export default connect(mapState, mapDispatch)(withStyles(s)(ManageBannerPlacement)); 